// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"8b474b82","258":"a8b19c7d","411":"bdc0904a","469":"a2ba2373","635":"ad2c5869","641":"0655cb25","654":"9b73d093","690":"0124102c","712":"9821d9a6","960":"3176eb79","992":"36c50e92"}[chunkId] + ".chunk.js";
};